import React, { useId } from 'react';
import { useTheme } from '@mui/material';

interface BrandMarkProps {
  size?: number;
}

export function BrandMark({ size = 22 }: BrandMarkProps) {
  const theme = useTheme();
  const gradId = useId();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
      style={{ flexShrink: 0, display: 'block' }}
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor={theme.palette.primary.main} />
          <stop offset="100%" stopColor={theme.palette.primary.dark} />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="20" height="20" rx="5.5" fill={`url(#${gradId})`} />
      <g transform="translate(4.39 4.39) scale(0.6)" fill={theme.palette.primary.contrastText}>
        <rect x="4" y="5.4" width="12" height="3.5" rx="1.75" />
        <rect x="9" y="10.25" width="11" height="3.5" rx="1.75" />
        <rect x="6" y="15.1" width="9" height="3.5" rx="1.75" />
      </g>
    </svg>
  );
}
